module.exports = __webpack_public_path__ + "img/watermelon_ios_802.png";